export enum ComponentTypes {
  Input = 'input',
  Textarea = 'textarea',
  Toggle = 'toggle',
  Checkbox = 'checkbox',
  Radio = 'radio',
  Select = 'select',
  Autocomplete = 'autocomplete',
  Phone = 'phone',
  RadioGroup = 'radioGroup',
  UploadThumbnail = 'uploadThumbnail',
  HorizontalLine = 'horizontalLine',
}
